import React from 'react';

import { StyledImage } from './styled-components';

const Image = (props) => {
  const {url, image} = props;
  const imageTag = <StyledImage src={image} {...props} />
  
  if(url) {
    return <a href={url}>{imageTag}</a>
  }

  return imageTag;
}

export default Image;